import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Code, SubCategory } from '@jms/model';

@Component({
    selector: 'codes-component',
    templateUrl: 'codes.component.html',
    styleUrls: ['codes.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CodesComponent implements OnInit, AfterViewInit {

  @Output() edit = new EventEmitter<Code>();
  @Output() select = new EventEmitter<Code>();
  @Output() loadMoreItems = new EventEmitter();

  @Input() public codes: Code[];
  @Input() public selected: string;
  @Input() public subCategory: SubCategory;
  @Input() public searchMode = false;

  @ViewChild('selectedItem') selectedItem: ElementRef;
  @ViewChild("cdkVirtualScrollViewport") viewPort: CdkVirtualScrollViewport;

  constructor() { }

  ngOnInit() { }

  ngAfterViewInit() {
    if (this.selectedItem) {
      this.selectedItem.nativeElement.scrollIntoView({ behavior: 'auto', block: 'center' });
    }
  }

  onClick(code: Code) {
    this.edit.emit(code);
  }

  onDoubleClick(code: Code) {
    this.select.emit(code);
  }

  public onScrolledIndexChange(event) {
    const scrollOffset = this.viewPort.measureScrollOffset();
    if (scrollOffset == 0) {
      return;
    }

    const end = this.viewPort.getRenderedRange().end;
    if (end === 0) {
      return;
    }

    const total = this.viewPort.getDataLength();

    if (end >= total) {
      this.loadMoreItems.emit();
    }
  }
}
